/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Generic checkbox multiselect.
// This is a more generic version of the checkbox_multiselect (CheckboxMultiSelect).
// That code relies mainly on all checkboxes on the form needing to be maganged.
// This code relies on data attributes and meta items being set to precisely select the checkboxes that need managing.

// Meta Items required
//# multiselect_child_checkboxes_container_id, the id to show / hide the list of checkboxes
//# multiselect_parent_checkbox_id, the controlling checkbox

// Data attributes required
//# data-multiselect-child-checkboxes-container-id, should match multiselect_child_checkboxes_container_id meta item.
//### Surrounds the list of checkboxes to be managed. If this is not defined, list of checkboxes will display by default.
//# data-multiselect-parent-checkbox-id, should match multiselect_parent_checkbox_id meta item. Add this to parent checkox
//### data-hide-unless-checked, if true, will hide the container if parent checkbox is not checked on first render
//# data-multiselect-child-checkbox-parent-id, should match multiselect_parent_checkbox_id meta item. Add this to all child checkboxes to be managed

namespace('Slzr.Page.GenericCheckboxMultiSelect', function(exports, top) {
  Slzr.jQuery(function($) {
    if (!$(document.body).is('.admin-events-edit,.admin-events-new,.admin-platforms-edit_config')) { return; }

    const container = $(`[data-multiselect-child-checkboxes-container-id=${Slzr.Meta.multiselect_child_checkboxes_container_id}]`);
    const parent_checkbox = $(`:checkbox[data-multiselect-parent-checkbox-id=${Slzr.Meta.multiselect_parent_checkbox_id}]`);
    const child_checkboxes = $(`:checkbox[data-multiselect-child-checkbox-parent-id=${Slzr.Meta.multiselect_parent_checkbox_id}]`);

    // Hide the container if parent checkbox is not checked
    if (parent_checkbox.prop("checked")) {
      container.show();
    } else {
      container.hide();
    }

    // Check all child checkboxes when parent is selected
    // Uncheck all child checkboxes when parent is deselected
    parent_checkbox.on("change", function(event) {
      if (parent_checkbox.prop("checked")) {
        if (container != null) { container.show(); }
        // check all checkboxes if none are previously selected
        return exports.updateCheckboxes(child_checkboxes);
      } 
        if (container != null) { return container.hide(); }
      
    });

    // Check parent check box if any child checkbox is checked
    // Uncheck parent if all child checkboxes are deslected
    return child_checkboxes.on("change", function(event) {
      if (child_checkboxes.filter(":checked").length > 0) {
        return parent_checkbox.prop("checked", true);
      } 
        return parent_checkbox.prop("checked", false);
      
    });
  });

  return exports.updateCheckboxes = child_checkboxes => {
    if (child_checkboxes.filter(":checked").length < 1) { return child_checkboxes.prop('checked', true); }
  };
});